import { Typography, Button } from "@mui/material";

// Reusable Base Component
const BaseButton = ({
	id,
	type = "button",
	disabled = false,
	className = "",
	title = "Button",
	onClick,

	size = "",
	width = "200px",
	titleClassName = "",
	titleColor,

	variant,
	color,

	backgroundColor,
	borderWidth,
	borderColor,
}) => {
	// Construct the dynamic style object
	const buttonStyle = {
		...(width && { width }),
		...(backgroundColor && { backgroundColor }),
		...(borderWidth && { borderWidth }),
		...(borderColor && { borderColor }),
	};

	return (
		<Button
			key={id}
			id={id}
			type={type}
			disabled={disabled}
			className={className}
			variant={variant}
			color={color}
			size={size || ""}
			style={buttonStyle}
			onClick={onClick}
		>
			<Typography
				className={titleClassName}
				sx={{ color: `${titleColor}!important` }}
				style={{ textTransform: "none" }}
			>
				<b>{title}</b>
			</Typography>
		</Button>
	);
};

const BackgroundDefaults = {
	variant: "contained",
	titleColor: "white",
};

const BorderDefaults = {
	variant: "outlined",
	backgroundColor: "white",
	borderWidth: "3px",
};

// -- Primary --
export const PrimaryBackgroundButton = (props) => (
	<BaseButton
		id="primary-background-button"
		color="primary"
		{...BackgroundDefaults}
		{...props}
	/>
);

export const PrimaryBorderButton = ({ titleColor = "primary", ...props }) => (
	<BaseButton
		id="primary-border-button"
		color="primary"
		borderColor={titleColor}
		titleColor={titleColor}
		{...BorderDefaults}
		{...props}
	/>
);

// -- Secondary --
export const SecondaryBackgroundButton = (props) => (
	<BaseButton
		id="secondary-background-button"
		color="secondary"
		{...BackgroundDefaults}
		{...props}
	/>
);

export const SecondaryBorderButton = (props) => (
	<BaseButton
		id="secondary-border-button"
		color="secondary"
		titleColor="secondary"
		{...BorderDefaults}
		{...props}
	/>
);

// -- Highlight (Third) --
export const HighlightBackgroundButton = (props) => (
	<BaseButton
		id="highlight-background-button"
		color="third"
		{...BackgroundDefaults}
		{...props}
	/>
);

export const HighlightBorderButton = (props) => (
	<BaseButton
		id="highlight-border-button"
		color="third"
		titleColor="third"
		{...BorderDefaults}
		{...props}
	/>
);

// -- Success --
export const SuccessBackgroundButton = (props) => (
	<BaseButton
		id="success-background-button"
		color="success"
		{...BackgroundDefaults}
		{...props}
	/>
);

// -- Error --
export const ErrorBackgroundButton = (props) => (
	<BaseButton
		id="error-background-button"
		color="error"
		{...BackgroundDefaults}
		{...props}
	/>
);

export const ErrorBorderButton = (props) => (
	<BaseButton
		id="error-border-button"
		color="error"
		titleColor="error"
		{...BorderDefaults}
		{...props}
	/>
);

// -- Info --
export const InfoBackgroundButton = (props) => (
	<BaseButton
		id="info-background-button"
		color="info"
		{...BackgroundDefaults}
		{...props}
	/>
);
